import BigNumber from "bignumber.js";

export const formatInput = (val: any) => {
    return new BigNumber(val.replace(/,/g, "")).toNumber()
};
export const formatInputString = (val: any) => {
    return new BigNumber(val.replace(/,/g, "")).toString()
};